<template>
  <div class="jf-card">
    <div class="jf-header">
      <h6 class="jf-title">Funil da Jornada</h6>
    </div>
    <div v-if="!funnel || funnel.length === 0" class="jf-empty">
      <i class="bx bx-filter"></i>
      <span>Nenhum dado disponivel</span>
    </div>
    <div v-else class="jf-list">
      <div v-for="(step, index) in funnel" :key="index" class="jf-step">
        <div class="jf-step-header">
          <span class="jf-step-number">{{ index + 1 }}</span>
          <span class="jf-step-label">{{ step.label || step.node_label || ('Passo ' + (index + 1)) }}</span>
          <span class="jf-step-count">{{ step.entered || 0 }}</span>
        </div>
        <div class="jf-bar-bg">
          <div class="jf-bar-fill" :style="{ width: barWidth(step) + '%' }"></div>
        </div>
        <div class="jf-step-meta">
          <small>
            <span class="jf-ok">{{ step.completed || 0 }} ok</span>
            <span class="jf-fail" v-if="step.failed">{{ step.failed }} falha</span>
          </small>
          <small class="jf-drop" v-if="step.drop_off">-{{ step.drop_off }}%</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    funnel: { type: Array, default: () => [] }
  },
  computed: {
    maxEntered () {
      if (!this.funnel || this.funnel.length === 0) return 1
      return Math.max(...this.funnel.map(s => s.entered || 0), 1)
    }
  },
  methods: {
    barWidth (step) {
      return ((step.entered || 0) / this.maxEntered) * 100
    }
  }
}
</script>

<style scoped>
.jf-card {
  background: #fff;
  border: 1px solid #e2e5eb;
  border-radius: 5px;
  padding: 20px;
  height: 100%;
}
.jf-header {
  margin-bottom: 16px;
}
.jf-title {
  font-size: 14px;
  font-weight: 700;
  color: #15181e;
  margin: 0;
}
.jf-empty {
  text-align: center;
  padding: 40px 0;
  color: #9aa1b2;
}
.jf-empty i {
  font-size: 28px;
  display: block;
  margin-bottom: 8px;
}
.jf-empty span {
  font-size: 13px;
}
.jf-list {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 8px;
  margin-right: -8px;
}
.jf-list::-webkit-scrollbar { width: 4px; }
.jf-list::-webkit-scrollbar-track { background: transparent; }
.jf-list::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }
.jf-step {
  padding: 10px 0;
  border-bottom: 1px solid #eceef2;
}
.jf-step:last-child {
  border-bottom: none;
}
.jf-step-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.jf-step-number {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eff6ff;
  color: #3b82f6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  margin-right: 8px;
  flex-shrink: 0;
}
.jf-step-label {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #15181e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jf-step-count {
  font-size: 13px;
  font-weight: 700;
  color: #15181e;
  margin-left: 8px;
}
.jf-bar-bg {
  height: 6px;
  background: #eceef2;
  border-radius: 3px;
  overflow: hidden;
}
.jf-bar-fill {
  height: 100%;
  background: #3b82f6;
  border-radius: 3px;
  transition: width 0.3s ease;
}
.jf-step-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
}
.jf-ok {
  font-size: 11px;
  color: #10b981;
  font-weight: 500;
}
.jf-fail {
  font-size: 11px;
  color: #ef4444;
  font-weight: 500;
  margin-left: 8px;
}
.jf-drop {
  font-size: 11px;
  color: #9aa1b2;
}
</style>
